import { Check, Copy } from '@phosphor-icons/react';
import { useState } from 'react';
import styles from './CopyButton.module.css';

interface CopyButtonProps {
	text: string;
	displayText?: string;
}

export function CopyButton({ text, displayText }: CopyButtonProps) {
	const [copied, setCopied] = useState(false);

	const handleCopy = async () => {
		await navigator.clipboard.writeText(text);
		setCopied(true);
		setTimeout(() => setCopied(false), 2000);
	};

	return (
		<span className={styles.wrapper}>
			{displayText && <span className={styles.text}>{displayText}</span>}
			<button
				type="button"
				className={[styles.copyButton, copied ? styles.copied : ''].filter(Boolean).join(' ')}
				onClick={handleCopy}
				title={copied ? 'Copied!' : 'Copy to clipboard'}
				aria-label={copied ? 'Copied!' : 'Copy to clipboard'}
			>
				{copied ? <Check size={12} weight="bold" /> : <Copy size={12} />}
			</button>
		</span>
	);
}
